const getGenderEntry = (gender) => {
  if (gender === "m" || gender === "male") return "male";
  if (gender === "f" || gender === "female") return "female";
  return "fallback";
};
const getGender = (genderContent, gender) => {
  const stateList = Object.keys(genderContent);
  const fallbackState = stateList[stateList.length - 1];
  const genderEntry = getGenderEntry(gender);
  return genderContent[genderEntry] ?? genderContent["fallback"] ?? genderContent[fallbackState];
};
export {
  getGender
};
//# sourceMappingURL=getGender.mjs.map